"use client";
import React from "react";
import { showPrice } from "@/lib/commonService";
import stl from "./productInTable.module.scss";
import getProductDetialHref from "@/src/utils/getProductDetialHref";
import { gaLoadedPromise, ProuctLikeOrHotClick } from "@/src/utils/gtagEvents";
import { addProductsToDetailEvent } from "@/src/models/emailData";

import { FmIcon, FmLink } from "@/ui-component";
import classnames from "classnames";
import { IChildren } from "@/src/app/interface";
import { useRateContext } from "@/src/provider";
import { account } from "@/store";
interface Props {
    data: any;
    type: string;
}

const ProductItem: React.FC<Props & IChildren> = (props) => {
    const { data, type } = props;

    const [getPrice] = useRateContext((state) => [state.getPrice]);

    const [favoriteArr, changeFavourite, addFavorite] = account.useAccountStore(
        (state) => [
            state.favoriteArr,
            state.changeFavourite,
            state.addFavorite,
        ],
    );

    const gaEvent = () => {
        const onSale = showPrice(data.product_price);
        addProductsToDetailEvent({
            colorId: data.color_id,
            price: onSale.price,
        });
        gaLoadedPromise().then(() => {
            ProuctLikeOrHotClick({
                type: type,
                products_id: data.products_id,
                colors_id: data.color_id,
            });
        });
    };

    const onSale = showPrice(data.product_price);
    const pHref = `${getProductDetialHref(
        data.products_id,
        `${data.master_categories_id}`,
    )}?color=${data.color_id}`;
    return (
        <>
            <FmLink onClickCapture={gaEvent} href={pHref}>
                {props.children[0]}
            </FmLink>
            <div className={classnames("default_layout", stl["item-icon"])}>
                <div className={"default_layout"}>
                    {props.children[1]}
                    <FmIcon
                        icon={`${
                            favoriteArr.includes(data.color_id)
                                ? "icon--full-heart"
                                : "icon--empty-heart"
                        }`}
                        className={stl["icon"]}
                        onClick={() =>
                            addFavorite({
                                productId: data.products_id,
                                colorsId: data.color_id,
                                activeColor: data,
                            })
                        }
                    />
                </div>
                <span
                    dangerouslySetInnerHTML={{
                        __html: getPrice(onSale.price),
                    }}
                    className={stl["price"]}
                ></span>
            </div>
        </>
    );
};

export default ProductItem;
